import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';
import { stateTagColorCodes, stateTagTextColorCodes } from 'farmx-web-ui';
import {
  STATUS_TAG_LIGHT_TEXT_STATES,
  STATUS_TAG_OVER_COLOR,
  STATUS_TAG_STATES,
} from '../../../constants';

export const StatusTag = ({
  width,
  text,
  state,
  tagStyle,
  icon,
  isCentered,
}) => {
  const { t } = useTranslation();
  const tagColor = state === STATUS_TAG_STATES.OVER
    ? STATUS_TAG_OVER_COLOR
    : stateTagColorCodes[state];
  const textColor = STATUS_TAG_LIGHT_TEXT_STATES.includes(state)
    ? '#ffffff'
    : stateTagTextColorCodes[state];
  return (
    <Tag
      color={tagColor}
      style={{
        ...{ width, textAlign: 'center' },
        ...tagStyle,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: isCentered ? 'center' :'start',
          color: textColor
        }}
      >
        {!icon ? <div><i className="icon icon-eyedropper icon-white" /></div>
          : (
            <div className="status-tag-icon-alignment">
              <i className={`icon ${icon} icon-white`} />
            </div>
          )}
        <div style={{ textTransform: 'capitalize', marginLeft: '4px' }}>{t(text)}</div>
      </div>
    </Tag>
  );
};

StatusTag.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  state: PropTypes.string.isRequired,
  tagStyle: PropTypes.shape({}),
  icon: PropTypes.func,
  isCentered: PropTypes.bool
};

StatusTag.defaultProps = {
  tagStyle: {},
  width: null,
  icon: null,
  isCentered: false,
};
